import { render, staticRenderFns } from "./EncodingRulesList.vue?vue&type=template&id=51d23093&scoped=true&"
import script from "./EncodingRulesList.vue?vue&type=script&lang=js&"
export * from "./EncodingRulesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d23093",
  null
  
)

export default component.exports